/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type ChatAgentPersona, ChatAgentPersonaFromJSONTyped, ChatAgentPersonaToJSON, ChatAgentPersonaToJSONTyped } from './ChatAgentPersona';
import { type ChatClientPersona, ChatClientPersonaFromJSONTyped, ChatClientPersonaToJSON, ChatClientPersonaToJSONTyped } from './ChatClientPersona';
import { type ChatWorkspaceDomainPersona, ChatWorkspaceDomainPersonaFromJSONTyped, ChatWorkspaceDomainPersonaToJSON, ChatWorkspaceDomainPersonaToJSONTyped } from './ChatWorkspaceDomainPersona';
import { type WorkspacePersona, WorkspacePersonaFromJSONTyped, WorkspacePersonaToJSON, WorkspacePersonaToJSONTyped } from './WorkspacePersona';
/**
 * 
 * @export
 * @interface Persona
 */
export interface Persona {
    /**
     * Unique identifier of the persona
     * @type {string}
     * @memberof Persona
     */
    id: string;
    /**
     * The type discriminator for this persona
     * @type {string}
     * @memberof Persona
     */
    type: PersonaTypeEnum;
}


/**
 * @export
 */
export const PersonaTypeEnum = {
    ChatClientPersona: 'ChatClientPersona',
    ChatAgentPersona: 'ChatAgentPersona',
    WorkspacePersona: 'WorkspacePersona',
    ChatWorkspaceDomainPersona: 'ChatWorkspaceDomainPersona'
} as const;
export type PersonaTypeEnum = typeof PersonaTypeEnum[keyof typeof PersonaTypeEnum];


/**
 * Check if a given object implements the Persona interface.
 */
export function instanceOfPersona(value: object): value is Persona {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PersonaFromJSON(json: any): Persona {
    return PersonaFromJSONTyped(json, false);
}

export function PersonaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Persona {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'ChatAgentPersona') {
            return ChatAgentPersonaFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'ChatClientPersona') {
            return ChatClientPersonaFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'ChatWorkspaceDomainPersona') {
            return ChatWorkspaceDomainPersonaFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'WorkspacePersona') {
            return WorkspacePersonaFromJSONTyped(json, ignoreDiscriminator);
        }

    }
    return {
        
        'id': json['id'],
        'type': json['type'],
    };
}

export function PersonaToJSON(json: any): Persona {
    return PersonaToJSONTyped(json, false);
}

export function PersonaToJSONTyped(value?: Persona | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'ChatAgentPersona':
                return ChatAgentPersonaToJSONTyped(value as ChatAgentPersona, ignoreDiscriminator);
            case 'ChatClientPersona':
                return ChatClientPersonaToJSONTyped(value as ChatClientPersona, ignoreDiscriminator);
            case 'ChatWorkspaceDomainPersona':
                return ChatWorkspaceDomainPersonaToJSONTyped(value as ChatWorkspaceDomainPersona, ignoreDiscriminator);
            case 'WorkspacePersona':
                return WorkspacePersonaToJSONTyped(value as WorkspacePersona, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
    };
}

